import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useGetPathToEntityDetail } from '../../hooks';

export const useNavigateToEventDetail = () => {
  const getPathToEntityDetail = useGetPathToEntityDetail();
  const navigate = useNavigate();

  return useCallback(
    async (id: string) => {
      await navigate(getPathToEntityDetail(id, { entityType: 'event' }));
    },
    [getPathToEntityDetail, navigate],
  );
};
